/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { toast } from 'react-toastify';
import { getManagerByDepartment, getRepsByManager } from '../../../api/medRepApi';
import { getHospitalDropdown } from '../../../api/HospitalApi';
import useTargetContext from '../context/useTargetContext';

const departmentOptions = [
  { label: 'ALL', value: null },
  { label: 'HTAR', value: 'HTAR' },
];
function Filter() {
  const {
    auth,
    setFilterForm,
    filterForm,
    monthsOptions,
    yearOptions,
    searchTarget,
    clearTarget,
    finalApprover,
  } = useContext(useTargetContext);
  const date = new Date();
  const [managerOptions, setManagerDrowndown] = useState([]);
  const [repOptions, setRepDrowndown] = useState([]);
  const [hospitalOptions, setHospitalDrowndown] = useState([]);

  const loadHospitalDropdown = async () => {
    // const months = filterForm?.month.map((item) => item.value);

    const months = filterForm?.month.map((row) =>
      row.value !== null ? parseFloat(row.value) : '',
    );
    const year = date.getFullYear().toString();

    const request = {
      head_id: '',
      department: filterForm?.department?.value,
      manager_id: finalApprover.includes(auth.user_id) ? filterForm?.manager?.value : auth.user_id,
      rep_id: filterForm?.htar?.value,
      date_from: '',
      date_to: '',
      month: [],
      keyword: '',
    };
    const res = await getHospitalDropdown(request);
    const { code, data } = res.data;
    const newHospital = data.filter((rows) => rows?.account_code !== null);
    if (code === '200') {
      const dropdownValue = newHospital?.map((row, index) => ({
        value: row?.account_code,
        label: row?.company_name,
      }));
      setHospitalDrowndown(dropdownValue);
      setHospitalDrowndown([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };
  const loadRepDropdown = async () => {
    const months = filterForm?.month.map((row) =>
      row.value !== null ? parseFloat(row.value) : '',
    );
    const year = date.getFullYear().toString();

    const request = {
      department: filterForm?.department?.value,
      manager_id: finalApprover.includes(auth.user_id) ? filterForm?.manager?.value : auth.user_id,
      date_from: '',
      date_to: '',
      month: [],
      keyword: '',
    };
    const res = await getRepsByManager(request);
    const { code, data } = res.data;
    if (code === '200') {
      const dropdownValue = data?.map((row) => ({
        value: row.rep_id,
        label: row.rep_name,
      }));
      setRepDrowndown([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };
  const loadManagersDropdown = async () => {
    try {
      const request = {
        department: filterForm.department.value ?? '',
        head_id: '',
        keyword: '',
      };
      const res = await getManagerByDepartment(request);
      const { code, data } = res.data;
      if (code === '200') {
        const dropdownValue = data?.map((row) => ({
          value: row.manager_id,
          label: row.manager_name,
        }));
        setManagerDrowndown(dropdownValue);
        setManagerDrowndown([{ label: 'ALL', value: null }, ...dropdownValue]);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  useEffect(() => {
    loadHospitalDropdown();
    loadRepDropdown();
    loadManagersDropdown();
  }, [filterForm]);

  return (
    <Box>
      <Grid container spacing={2}>
        {auth?.designation === 'admin' ||
        auth?.designation === 'sub_admin' ||
        auth?.level === 3 ||
        auth?.level === 4 ? (
          <Grid md={2}>
            <Autocomplete
              disablePortal
              id='department'
              disableClearable
              fullWidth
              options={departmentOptions}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='Department' />}
              size='small'
              value={
                filterForm.department
                  ? departmentOptions.find((row) => row.value === filterForm.department.value)
                  : null
              }
              onChange={(e, newValue) => handleChangeFilter(e, newValue, 'department')}
              sx={{ backgroundColor: '#fff' }}
            />
          </Grid>
        ) : (
          ''
        )}
        {finalApprover.includes(auth.user_id) ? (
          <Grid md={2}>
            <Autocomplete
              disablePortal
              id='manager'
              disableClearable
              fullWidth
              options={managerOptions}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='Managers (HTAM)' />}
              size='small'
              value={filterForm.manager}
              onChange={(e, newValue) => handleChangeFilter(e, newValue, 'manager')}
              sx={{ backgroundColor: '#fff' }}
            />
          </Grid>
        ) : (
          ''
        )}
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='htar'
            disableClearable
            fullWidth
            options={repOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='HTAR' />}
            size='small'
            value={filterForm.htar}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'htar')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='hospital'
            disableClearable
            fullWidth
            options={hospitalOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Hospital Name' />}
            size='small'
            value={filterForm?.hospital}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'hospital')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='months'
            disableClearable
            multiple
            fullWidth
            options={monthsOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            autoComplete
            includeInputInList
            filterSelectedOptions
            getOptionLabel={(option) => (option.label ? option.label : '')}
            value={filterForm.month ?? []}
            noOptionsText='No Months'
            onChange={(event, newValue) => {
              let updatedNewValue = newValue;

              if (newValue.length === 0) {
                // if remove all month option set default to all
                updatedNewValue = [monthsOptions[0]];
              } else if (newValue[newValue.length - 1].value === null) {
                // if last selected in ALL, remove all other options and retain ALL
                updatedNewValue = [monthsOptions[0]];
              } else if (newValue.length !== 1) {
                // if selected other months, remove ALL in selected options
                updatedNewValue = newValue.filter(
                  (option) => option.value !== monthsOptions[0].value,
                );
              }

              setFilterForm({
                ...filterForm,
                month: updatedNewValue,
              });
            }}
            isOptionEqualToValue={(option, selected) => option.value === selected.value}
            renderInput={(params) => <TextField {...params} label='Months' fullWidth />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            size='small'
          />
        </Grid>
        <Grid md={2}>
          <Button variant='contained' color='success' onClick={searchTarget}>
            Generate
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={clearTarget}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
export default Filter;
